export type LinkGroup = 'account' | 'bokadirekt' | 'legal';

export enum Identifier {
  Login = 'login',
  Bookings = 'bookings',
  Favorites = 'favorites',
  Giftcard = 'giftcard',
  Wellnesscard = 'wellnesscard',
  Cancel_by_code = 'cancel-by-code',
  About = 'about',
  Blog = 'blog',
  Faq = 'faq',
  Advice = 'advice',
  Career = 'career',
  Support = 'support',
  Ethical_policy = 'ethical_policy',
  Privacy_policy = 'privacy_policy',
  Cookie_policy = 'cookie_policy',
  Terms = 'terms',
}

export type Link = {
  label: string;
  identifier: Identifier;
  to?: string;
  external?: boolean;
};
